<h2 mat-dialog-title>Confirmation</h2>

<mat-dialog-content>
  {{ data.message }}
</mat-dialog-content>

<mat-dialog-actions class="right-aligned-actions">
  <button mat-button (click)="onCancel()" class="btn">Cancel</button>
  <button mat-button (click)="onConfirm()" class="btn btn-primary">Confirm</button>
</mat-dialog-actions>
